/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 8a78c200bf2bfca088d7c3d790c6bcac */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AuthenticateUserFieldName = "EMAIL" | "PASSWORD" | "%future added value";
export type useLoginMutationVariables = {
    email: string;
    password: string;
};
export type useLoginMutationResponse = {
    readonly authenticateUser: {
        readonly __typename: "AuthenticateUserSuccess";
        readonly viewer: {
            readonly currentUser: {
                readonly customerNumber: string;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"SessionLayout_viewer">;
        };
    } | {
        readonly __typename: "AuthenticateUserInvalidInput";
        readonly fieldErrors: ReadonlyArray<{
            readonly fieldName: AuthenticateUserFieldName;
            readonly errors: ReadonlyArray<string>;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
};
export type useLoginMutation = {
    readonly response: useLoginMutationResponse;
    readonly variables: useLoginMutationVariables;
};



/*
mutation useLoginMutation(
  $email: String!
  $password: String!
) {
  authenticateUser(email: $email, password: $password) {
    __typename
    ... on AuthenticateUserSuccess {
      viewer {
        currentUser {
          customerNumber
          id
        }
        ...SessionLayout_viewer
      }
    }
    ... on AuthenticateUserInvalidInput {
      fieldErrors {
        fieldName
        errors
      }
    }
  }
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "email",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "password",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  },
  {
    "kind": "Variable",
    "name": "password",
    "variableName": "password"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customerNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "type": "AuthenticateUserInvalidInput",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "fieldErrors",
      "storageKey": null,
      "args": null,
      "concreteType": "AuthenticateUserInvalidField",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "fieldName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "errors",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useLoginMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authenticateUser",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "type": "AuthenticateUserSuccess",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "viewer",
                "storageKey": null,
                "args": null,
                "concreteType": "Viewer",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "SessionLayout_viewer",
                    "args": null
                  }
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "useLoginMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authenticateUser",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "type": "AuthenticateUserSuccess",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "viewer",
                "storageKey": null,
                "args": null,
                "concreteType": "Viewer",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentUser",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fullName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "session",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Session",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "token",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expiresAt",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "useLoginMutation",
    "id": null,
    "text": "mutation useLoginMutation(\n  $email: String!\n  $password: String!\n) {\n  authenticateUser(email: $email, password: $password) {\n    __typename\n    ... on AuthenticateUserSuccess {\n      viewer {\n        currentUser {\n          customerNumber\n          id\n        }\n        ...SessionLayout_viewer\n      }\n    }\n    ... on AuthenticateUserInvalidInput {\n      fieldErrors {\n        fieldName\n        errors\n      }\n    }\n  }\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '5b46572e1bf412dbd906a6672c2fd105';
export default node;
